import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import EnterpriseContent from "./EnterpriseContent";
import enterpriseService from '../../service/firebase/enterpriseService';
import type { Enterprise } from '../../type';

const EnterprisePage = () => {
  const queryClient = useQueryClient();

  // 기업 목록 조회
  const { data: enterprises = [], isLoading, error } = useQuery({
    queryKey: ['enterprises'],
    queryFn: () => enterpriseService.getAllEnterprises(),
  });

  // 기업 추가
  const addEnterpriseMutation = useMutation({
    mutationFn: (enterprise: Enterprise) => enterpriseService.createEnterprise(enterprise),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['enterprises'] });
    },
  });

  // 기업 수정
  const updateEnterpriseMutation = useMutation({
    mutationFn: ({ enterpriseId, enterprise }: { enterpriseId: string; enterprise: Partial<Enterprise> }) =>
      enterpriseService.updateEnterprise(enterpriseId, enterprise),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['enterprises'] });
    },
  });

  // 기업 삭제
  const deleteEnterpriseMutation = useMutation({
    mutationFn: (enterpriseId: string) => enterpriseService.deleteEnterprise(enterpriseId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['enterprises'] });
    },
  });

  const handleAddEnterprise = async (enterprise: Enterprise) => {
    await addEnterpriseMutation.mutateAsync(enterprise);
  };

  const handleUpdateEnterprise = async (enterprise: Enterprise) => {
    await updateEnterpriseMutation.mutateAsync({
      enterpriseId: enterprise.enterpriseId,
      enterprise: enterprise,
    });
  };

  const handleDeleteEnterprise = async (enterpriseId: string) => {
    await deleteEnterpriseMutation.mutateAsync(enterpriseId);
  };

  return (
    <EnterpriseContent 
      enterprises={enterprises}
      loading={isLoading}
      error={error?.message || null}
      addEnterprise={handleAddEnterprise}
      updateEnterprise={handleUpdateEnterprise}
      deleteEnterprise={handleDeleteEnterprise}
    />
  );
};

export default EnterprisePage;